<div class="step-container step-container-success">
  <div class="step-header">
    <div class="step-header-icon success-icon"><i class="fas fa-check-circle" aria-hidden="true"></i></div>
    <h2>Contraseña actualizada</h2>
    <p>Su contraseña de Certifirma Digital Virtual se ha actualizado correctamente.</p>
  </div>
  <div class="button-container">
    <button type="button" class="btn btn-secondary" (click)="reiniciar.emit()">Recuperar otra contraseña</button>
    <button type="button" class="btn btn-primary" (click)="cerrar.emit()">Ir al inicio</button>
  </div>
</div>
